import { holeCardsParser } from '../../../types/cardTypes';
import { booleanParser, encodedStringParser, numberParser, stringParser } from '../inboundParsers';
export const SHOW_PLAYER_BUBBLE_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'playerId', parser: numberParser },
        { name: 'html', parser: encodedStringParser },
        { name: 'textRgbString', parser: stringParser },
        { name: 'backgroundRgbString', parser: stringParser },
        { name: 'isBold', parser: booleanParser },
        { name: 'cards', parser: holeCardsParser }
    ]
};
